import { PAYMENT_NETWORKS } from '../../utils/enums';

/* eslint no-template-curly-in-string: "off" */
const paymentNetworks = {
  [PAYMENT_NETWORKS.ACH_DASH]: require('./achDash').default,
  [PAYMENT_NETWORKS.ACH_FINIX]: require('./achFinix').default,
  [PAYMENT_NETWORKS.ACH_TREMENDOUS]: require('./achTremendous').default,
  [PAYMENT_NETWORKS.AMAZON_BALANCE]: require('./amazonBalance').default,
  [PAYMENT_NETWORKS.BASS_PRO_SHOPS]: require('./bassProShops').default,
  [PAYMENT_NETWORKS.BEST_BUY]: require('./bestBuy').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_AMAZON]: require('./blackhawkAmazon').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_GAP]: require('./gap').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_NIKE]: require('./nike').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_SAFEWAY]: require('./safeway').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_SUBWAY]: require('./subway').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_TARGET_CLASSACTION]: require('./targetClassaction').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_WALMART]: require('./walmart').default,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_WHOLEFOODS]: require('./wholeFoods').default,
  [PAYMENT_NETWORKS.EGIFT_TREMENDOUS_AMAZON]: require('./tremendousAmazon').default,
  [PAYMENT_NETWORKS.JETBLUE_TRAVEL_BANK]: require('./travelBank').default,
  [PAYMENT_NETWORKS.MASTERCARD]: require('./mastercard').default,
  [PAYMENT_NETWORKS.OCT_FINIX]: require('./finix').default,
  [PAYMENT_NETWORKS.OFFICE_DEPOT]: require('./officeDepot').default,
  [PAYMENT_NETWORKS.PAPER_CHECK]: require('./paperCheck').default,
  [PAYMENT_NETWORKS.PAYPAL_ADAPTIVE_PAYMENTS]: require('./paypalAdaptive').default,
  [PAYMENT_NETWORKS.PAYPAL_DASH]: require('./paypalDash').default,
  [PAYMENT_NETWORKS.PAYPAL_PAYOUTS]: require('./paypalPayouts').default,
  [PAYMENT_NETWORKS.PAYPAL_TREMENDOUS]: require('./tremendousPayPal').default,
  [PAYMENT_NETWORKS.PAYPAL_TREMENDOUS_INTERNATIONAL]: require('./tremendousPayPal').default,
  [PAYMENT_NETWORKS.PHYSICALDEBITATMCARD_BLACKHAWK_MASTERCARD]: require('./physicalDebitCardATM').default,
  [PAYMENT_NETWORKS.PHYSICALDEBITCARD_BLACKHAWK_MASTERCARD]: require('./physicalDebitCard').default,
  [PAYMENT_NETWORKS.STARBUCKS]: require('./starbucks').default,
  [PAYMENT_NETWORKS.TARGET]: require('./target').default,
  [PAYMENT_NETWORKS.VENMO]: require('./venmo').default,
  [PAYMENT_NETWORKS.VENMO_DASH]: require('./dashVenmo').default,
  [PAYMENT_NETWORKS.VENMO_TREMENDOUS]: require('./tremendousVenmo').default,
  [PAYMENT_NETWORKS.VIRTUALDEBITCARD_DASH_MASTERCARD]: require('./dashVirtualMastercard').default,
  [PAYMENT_NETWORKS.VIRTUALDEBITCARD_TREMENDOUS_MASTERCARD]: require('./tremendousVirtualMastercard').default,
};

export default paymentNetworks;
